<template>
  <USlideover v-model:open="isOpen" :title="$t('DjCartLayer.cart')">
    <template #body>
      <div class="bg-gray-100 p-3 rounded-lg text-center">
        {{ $t('DjCartLayer.shippingMessage') }}
      </div>
      <div class="flex-1 overflow-y-auto pt-2 space-y-4 max-h-[calc(100vh-300px)]">
        <div
          v-for="cartLine in cartProducts"
          :key="cartLine.key"
          class="flex items-start justify-between border p-2 rounded-lg items-center"
        >
          <DjCartMiniProducts :cart-line="cartLine" />
        </div>
      </div>

      <div class="pt-4 bg-white sticky bottom-0">
        <!-- Totals -->
        <div class="mb-4">
          <div class="flex justify-between font-bold text-md">
            <span>
              {{ $t('DjCartLayer.totalHt') }}/ {{ cartLines.length }}
              {{ $t('DjCartLayer.products') }}
            </span>
            <span>{{ totalHTVA }} €</span>
          </div>
          <div class="flex justify-between text-gray-600">
            <span>{{ $t('DjCartLayer.totalTva') }}</span>
            <span>{{ totalTVA }} €</span>
          </div>
          <div class="flex justify-between font-bold text-md mt-2">
            <span>{{ $t('DjCartLayer.totalTtc') }}</span>
            <span>{{ totalTTC }} €</span>
          </div>
        </div>

        <!-- Actions -->
        <div class="flex justify-between space-x-2">
          <UButton
            color="primary"
            class="flex-1 text-white items-center justify-center"
            :label="$t('DjCartLayer.continueShopping')"
            @click="closeLayer"
          />

          <UButton
            color="primary"
            class="flex-1 text-white items-center justify-center"
            :label="$t('DjCartLayer.goToCart')"
            @click="goToCart"
          />
        </div>
      </div>
    </template>
  </USlideover>
</template>

<script setup lang="ts">
  const router = useRouter();
  const { getCartOfferId, getCartOfferPriceWithoutTax, getCartSupplierName } = useCart();
  const { getFormattedPrice } = useUtils();
  const { getUserCurrency } = useUser();
  const currency = computed(() => getUserCurrency());
  const emit = defineEmits(['deleted', 'error']);
  const isOpen = ref(false);
  const cartStore = useCartStore();
  const cart = computed(() => cartStore.cart);
  const cartLines = computed(() => cartStore.cartLines);
  const localePath = useLocalePath();

  function goToCart() {
    router.push(localePath(`/checkout/cart`));
  }

  const mapCartLineToProduct = (line: any, index: number, currency: string) => {
    const supplierName = getCartSupplierName(line);
    const priceHT = getCartOfferPriceWithoutTax(line) || 0;
    const totalHT = getFormattedPrice(priceHT * line.quantity, currency);
    const offerPriceId = getCartOfferId(line);
    return {
      id: index,
      product: line,
      supplierName: supplierName,
      priceHT: getFormattedPrice(priceHT, currency) || 0,
      priceHTValue: priceHT || 0,
      quantity: line.quantity || 0,
      offerPriceId,
      total: totalHT,
      actions: '',
    };
  };
  const cartProducts = computed(() => {
    return cartLines.value.map((line: any, index: number) =>
      mapCartLineToProduct(line, index, currency.value)
    );
  });
  const totalHTVA = computed(() => {
    return cart.value.totalPrice.priceWithoutTax.toFixed(2);
  });

  const totalTVA = computed(() => {
    return cart.value.totalPrice.taxAmount.toFixed(2);
  });

  const totalTTC = computed(() => {
    return cart.value.totalPrice.priceWithTax.toFixed(2);
  });
</script>
